import { LoquixAttachmentChip } from './loquix-attachment-chip.js';

if (!customElements.get('loquix-attachment-chip')) {
  customElements.define('loquix-attachment-chip', LoquixAttachmentChip);
}
